/* eslint-disable */
/*
* crews.js
*
* Description: Holds 'Stores' Logic for Module:'Crews'.
* Note: I copied this File from 'People' Project.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import { fil } from 'date-fns/locale';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {
    // >>> crews -----------------------------------------
    crews_crewsOnAirplane: [],
    crews_combinedCrewsOnAirplane: [],
    crews_memberOnCrew: [],
    crews_memberOnCrew_Edited: [],
    crews_memberOnCrew_Edited_Before: [],
    crews_resourcesOfDepartment: [],
    crews_resourcesOfDepartment_Filtered: [],
    crews_resourcesOfDepartment_WithInactive: [],
    crews_FlightData_FromCrewsToUpdate: [], // list of flightIds
    // >>> filtering/sorting -----------------------------
    crews_filterTerm_ResourcesOfDepartment: '',
    crews_sortBy_MemberOfCrew: 'none',
};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Crews' - Load Crew(s)
    ***************************************************************************/
    /***************************************************************************
    * get_CrewsOnAirplane()
    *
    * Desc:
    * Note:
    *
    */
    get_CrewsOnAirplane: state => {

        return state.crews_crewsOnAirplane;

    }, // eo function get_CrewsOnAirplane()


    /***************************************************************************
    * get_combinedCrewsOnAirplane()
    *
    * Desc:
    * Note:
    *
    */
    get_combinedCrewsOnAirplane: state => {

        return state.crews_combinedCrewsOnAirplane;

    }, // eo function get_Crews()


    /***************************************************************************
    * get_MemberOnCrew()
    *
    * Desc:
    * Note:
    *
    */
    get_MemberOnCrew: state => {

        return state.crews_memberOnCrew;

    }, // eo function get_MemberOnCrew()


    /***************************************************************************
    * get_MemberOnCrew_Edited()
    *
    * Desc:
    * Note:
    *
    */
    get_MemberOnCrew_Edited: state => {

        return state.crews_memberOnCrew_Edited;

    }, // eo function get_MemberOnCrew_Edited()


    /***************************************************************************
    * get_MemberOnCrew_Edited_Before()
    *
    * Desc:
    * Note:
    *
    */
    get_MemberOnCrew_Edited_Before: state => {

        return state.crews_memberOnCrew_Edited_Before;

    }, // eo function get_MemberOnCrew_Edited_Before()


    /***************************************************************************
    * get_crews_ResourcesOfDepartment()
    *
    * Desc:
    * Note:
    *
    */
    get_crews_ResourcesOfDepartment: state => {

        return state.crews_resourcesOfDepartment;

    }, // eo function get_crews_ResourcesOfDepartment()


    /***************************************************************************
    * get_crews_ResourcesOfDepartment_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_crews_ResourcesOfDepartment_Filtered: state => {

        return state.crews_resourcesOfDepartment_Filtered;

    }, // eo function get_crews_ResourcesOfDepartment()


    /***************************************************************************
    * get_crews_FilterTerm_ResourcesOfDepartment()
    *
    * Desc:
    * Note:
    *
    */
    get_crews_FilterTerm_ResourcesOfDepartment: state => {

        return state.crews_filterTerm_ResourcesOfDepartment;

    }, // eo function get_crews_FilterTerm_ResourcesOfDepartment()


    /***************************************************************************
    * get_crews_SortBy_MemberOfCrew()
    *
    * Desc:
    * Note:
    *
    */
    get_crews_SortBy_MemberOfCrew: state => {

        return state.crews_sortBy_MemberOfCrew;

    }, // eo function get_crews_SortBy_MemberOfCrew()


    /***************************************************************************
    * get_crews_FlightData_FromCrewsToUpdate()
    *
    * Desc:
    * Note:
    *
    */
    get_crews_FlightData_FromCrewsToUpdate: state => {

        return state.crews_FlightData_FromCrewsToUpdate;

    }, // eo function get_crews_FlightData_FromCrewsToUpdate()


    /***************************************************************************
    * get_crews_Complete_Names()
    *
    * Desc:
    * Note: Sort here!
    *
    */
    get_crews_Complete_Names: state => payload => {

        let filtered = [],
            filtered_final = [],
            order = null;


        // >>> add order to each item ---------------------
        state.crews_resourcesOfDepartment_WithInactive.forEach(item => {
            if (item.contractFunction === 'CP') {
                order = '1';
            } else if (item.contractFunction === 'FO') {
                order = '2';
            } else if (item.contractFunction === 'SCCM') {
                order = '3';
            } else if (item.contractFunction === 'CA') {
                order = '4';
            }
            item.order = order;
        });


        // >>> filter items -------------------------------
        payload.forEach(member => {
            state.crews_resourcesOfDepartment_WithInactive.forEach(resource => {
                if (member === resource.contract3Code) {
                    filtered = [...filtered, resource];
                }
            });
        });


        // >>> sort items ---------------------------------
        filtered = filtered.sort((a, b) => {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }

            if (a.genLastname < b.genLastname) {
                return -1;
            }
            if (a.genLastname > b.genLastname) {
                return 1;
            }
        });


        // >>> create final array -------------------------
        filtered.forEach(resource => {
            filtered_final = [...filtered_final, resource.fullName + ' ('+ resource.contractFunction + ')'];
        });


        return filtered_final;

    }, // eo function get_crews_Complete_Names()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'People' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_ResourcesOfDepartment()
    *
    * Desc: Reset
    * Note:
    *
    */
    mut_reset_ResourcesOfDepartment: (state) => {

        state.crews_resourcesOfDepartment = [];

    }, // eo function mut_reset_ResourcesOfDepartment()


    /***************************************************************************
    * mut_reset_crews_ResourcesOfDepartment_Filtered()
    *
    * Desc: Reset resourcesOfDepartment_Filtered AND memberOnCrew_Edited.
    * Note:
    *
    */
    mut_reset_crews_ResourcesOfDepartment_Filtered: (state, payload) => {

        state.crews_memberOnCrew_Edited = { ...state.crews_memberOnCrew };
        payload.context.commit('mut_set_MemberOnCrew', { response: state.crews_memberOnCrew });

    }, // eo function mut_reset_crews_ResourcesOfDepartment_Filtered()


    /***************************************************************************
    * mut_set_ResourcesOfDepartment()
    *
    * Desc: Set Resources of Department from Calls Reponse.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore this is a 'stupid' Hack here.
    * Note: Build 'filterableName'.
    * Note: See: https://github.com/SundairIT/SunCrew-Crewplanning2/issues/17
    *
    */
    mut_set_ResourcesOfDepartment: (state, payload) => {

        let filterableName = null,
            fullName = null,
            crews_resourcesOfDepartment_Copy = [];


        if (state.crews_resourcesOfDepartment.length === 0) {                   // first load

            state.crews_resourcesOfDepartment = [...payload.response];
            state.crews_resourcesOfDepartment_WithInactive = [...payload.response];

        } else {                                                                // second load

            state.crews_resourcesOfDepartment = state.crews_resourcesOfDepartment.concat([...payload.response]);
            state.crews_resourcesOfDepartment_WithInactive = state.crews_resourcesOfDepartment_WithInactive.concat([...payload.response]);

            // >>> Filter -----------------------
            state.crews_resourcesOfDepartment.forEach((item) => {
                filterableName = item.genLastname + ' ' + item.genFirstName + ' ' + item.contract3Code;
                item.filterableName = filterableName;
                fullName = item.genLastname.trim() + ', ' + item.genFirstName.trim();
                item.fullName = fullName;

                switch (item.contractFunction) {
                    case "CP":
                        item.sortingIndex = 1;
                        break;
                    case "FO":
                        item.sortingIndex = 2;
                        break;
                    case "SCCM":
                        item.sortingIndex = 3;
                        break;
                    case "CA":
                        item.sortingIndex = 4;
                        break;
                    default:
                        item.sortingIndex = 5;
                        break;
                }
            });


            // run through array and remove all items where 'active' is false
            crews_resourcesOfDepartment_Copy = state.crews_resourcesOfDepartment.filter((item) => {
                return item.active === true;
            });

            // >>> active only ------------------
            state.crews_resourcesOfDepartment = crews_resourcesOfDepartment_Copy;

        }

    }, // eo funtion mut_set_ResourcesOfDepartment()




    /***************************************************************************
    * Mutations: 'Crews' - Load Crew(s)
    ****************************************************************************
    /***************************************************************************
    * mut_set_CrewsOnAirplane()
    *
    * Desc: Set Crews from Calls Reponse.
    * Note: Reset of memberOnCrew needed for the case: members are loaded,
    * Note: switch to people-scetion, switch back to crews-section
    *
    */
    mut_set_CrewsOnAirplane: (state, payload) => {

        let combinedCrewsOnAirplane = [],
            aircraftConfigs = [],
            children = [];


        if (payload.response) {
            state.crews_crewsOnAirplane = [...payload.response];

            //reset memberOnCrews
            state.crews_memberOnCrew_Edited = [];
            state.crews_memberOnCrew_Edited_Before = [];
            state.crews_memberOnCrew = [];
        }

        aircraftConfigs = payload.context.rootState.shared.people_aircraftConfigs;

        aircraftConfigs.forEach(aircraft => {
            children = [];

            state.crews_crewsOnAirplane.forEach(crew => {
                if (crew.idAircraft === aircraft.id) {
                    children.push(crew);
                }
            });

            if (children.length > 0) {
                combinedCrewsOnAirplane.push({ id: aircraft.idAircraft, name: aircraft.code, children: children });
            }

        });

        state.crews_combinedCrewsOnAirplane = combinedCrewsOnAirplane;

    }, // eo function mut_set_CrewsOnAirplane()


    /***************************************************************************
    * mut_set_MemberOnCrew()
    *
    * Desc: Set Crew from Calls Reponse.
    * Note:
    *
    */
    mut_set_MemberOnCrew: (state, payload) => {

        let crew = [...payload.response.crew],
            fullName = "",
            resourcesOfDepartmentCopy = [],
            crewCopy = [],
            resourcesOfDepartmentFiltered = [];


        crew.forEach((item) => {
            fullName = item.genLastname.trim() + ', ' + item.genFirstName.trim();
            item.fullName = fullName;

            item.idHrDepartmentFake = item.idHrDepartment === 11 ? "Cabin" : "Cockpit";
            switch (item.contractFunction) {
                case "CP":
                    item.sortingIndex = 1;
                    break;
                case "FO":
                    item.sortingIndex = 2;
                    break;
                case "SCCM":
                    item.sortingIndex = 3;
                    break;
                case "CA":
                    item.sortingIndex = 4;
                    break;
                default:
                    item.sortingIndex = 5;
                    break;
            }
        });

        payload.response.crew = crew;

        state.crews_memberOnCrew = { ...payload.response };

        // filter the resources list
        resourcesOfDepartmentCopy = [...state.crews_resourcesOfDepartment];
        crewCopy = [...payload.response.crew];
        resourcesOfDepartmentFiltered = resourcesOfDepartmentCopy.filter((x) => {
            return !crewCopy.find((y) => x.id === y.id);
        });

        state.crews_resourcesOfDepartment_Filtered = [...resourcesOfDepartmentFiltered];
        state.crews_memberOnCrew_Edited = { ...payload.response };
        state.crews_memberOnCrew_Edited_Before = { ...payload.response }; // save before Zustand


        if (payload.context) {
            payload.context.commit('mut_sort_ResourcesOfDepartment');
        }

    }, // eo function mut_set_MemberOnCrew()


    /***************************************************************************
    * find_crew_for_mut_set_MemberOnCrew()
    *
    * Desc: Build Crew for using in 'mut_set_MemberOnCrew'
    * Note: Kind of PreStep.
    * Note: See: https://github.com/SundairIT/SunCrew-Crewplanning2/issues/17
    *
    */
    find_crew_for_mut_set_MemberOnCrew: (state, payload) => {

        let foundCompleteResources = [],
            crewCopy = [],
            resourcesOfDepartmentCopy = [];


        resourcesOfDepartmentCopy = [...state.crews_resourcesOfDepartment_WithInactive]; // bef: ...state.crews_resourcesOfDepartment
        crewCopy = [...payload.response]; // its only the crewCodes here


        foundCompleteResources = resourcesOfDepartmentCopy.filter((x) => {
            return crewCopy.find((y) => x.contract3Code === y);
        });


        // >>> now use this .. for 'mut_set_MemberOnCrew2'
        payload.context.commit('mut_set_MemberOnCrew',  { response: { "crew": foundCompleteResources }, context: payload.context });

    }, // eo function find_crew_for_mut_set_MemberOnCrew()


    /***************************************************************************
    * set_crews_FlightData_FromCrewsToUpdate()
    *
    * Desc:
    * Note:
    *
    */
    set_crews_FlightData_FromCrewsToUpdate: (state, payload) => {

        state.crews_FlightData_FromCrewsToUpdate = payload;

    }, // eo function set_crews_FlightData_FromCrewsToUpdate()


    /***************************************************************************
    * mut_set_updateCreateCrew()
    *
    * Desc: Adds the Created or Updated Crew to the existing Crews.
    * Note: 'editorMode' decides if we have to 'update' or to 'create' (add).
    * Note: { response: response.data, editorMode: payload.editorMode, context: payload.context }
    *
    */
    mut_set_updateCreateCrew: (state, payload) => {

        let crewsCopy = [];


        if (payload.editorMode === 'create') {
            crewsCopy = [...state.crews_crewsOnAirplane];
            crewsCopy.push(payload.response);
        }

        if (payload.editorMode === 'update') {
            state.crews_crewsOnAirplane.forEach((crew) => {
                if (crew.id === payload.response.id) {
                    crew = payload.response; // overwrite
                }

                crewsCopy.push(crew);
            });
        }

        if (payload.editorMode === 'relocate') {
            crewsCopy = [...state.crews_crewsOnAirplane];
            crewsCopy.push(payload.response);
        }

        state.crews_crewsOnAirplane = crewsCopy;

        payload.context.commit('mut_set_CrewsOnAirplane', { context: payload.context });
        payload.context.commit('mut_set_MemberOnCrew', { response: payload.response });

    }, // eo function mut_set_updateCreateCrew()


    /***************************************************************************
    * mut_reset_crews_MemberOnCrew()
    *
    * Desc: Reset memberOnCrew.
    * Note:
    *
    */
    mut_reset_crews_MemberOnCrew: (state) => {

        state.crews_memberOnCrew = [];
        state.crews_memberOnCrew_Edited = [];
        state.crews_memberOnCrew_Edited_Before = [];

    }, // eo function mut_reset_crews_MemberOnCrew()


    /***************************************************************************
    * mut_update_crews_ResourcesOfDepartment()
    *
    * Desc: Reset resourcesOfDepartment_Filtered.
    * Note:
    *
    */
    mut_update_crews_ResourcesOfDepartment: (state, payload) => {

        state.crews_resourcesOfDepartment_Filtered = [...payload];

    }, // eo function mut_update_crews_ResourcesOfDepartment()


    /***************************************************************************
    * mut_update_crews_MemberOnCrew()
    *
    * Desc: Reset memberOnCrew.
    * Note:
    *
    */
    mut_update_crews_MemberOnCrew: (state, payload) => {

        state.crews_memberOnCrew_Edited.crew = [...payload];

    }, // eo function mut_update_crews_MemberOnCrew()


    /***************************************************************************
    * mut_update_crews_FilterTerm_ResourcesOfDepartment()
    *
    * Desc: Update Filter Term and resourcesOfDepartment_Filtered.
    * Note: Reset the filtered Resources, filter out the current crew members
    * Note: (memberOnCrew), and apply the filter term.
    * Note: This is needed because of the bottom sheet structure.
    *
    */
    mut_update_crews_FilterTerm_ResourcesOfDepartment: (state, payload) => {

        state.crews_filterTerm_ResourcesOfDepartment = payload.payload;

        //reset to inital state
        state.crews_resourcesOfDepartment_Filtered = state.crews_resourcesOfDepartment;

        //filter out the current crew
        if (state.crews_memberOnCrew_Edited.crew) {
            state.crews_resourcesOfDepartment_Filtered = state.crews_resourcesOfDepartment_Filtered.filter((x) => {
                return !state.crews_memberOnCrew_Edited.crew.find((y) => x.id === y.id);
            });
        }

        //apply filter term
        state.crews_resourcesOfDepartment_Filtered = state.crews_resourcesOfDepartment_Filtered.filter(x => x.filterableName.match(new RegExp(payload.payload, 'i')));

        payload.context.commit('mut_sort_ResourcesOfDepartment');

    }, // eo function mut_update_crews_FilterTerm_ResourcesOfDepartment()


    /***************************************************************************
    * mut_update_crews_SortBy_MemberOfCrew()
    *
    * Desc: Update SortBy and memberOnCrew.
    * Note:
    *
    */
    mut_update_crews_SortBy_MemberOfCrew: (state, payload) => {

        switch (payload) {
            case 'firstname':
                state.crews_memberOnCrew_Edited.crew.sort((a, b) => a.genFirstName > b.genFirstName ? 1 : -1);
                break;
            case 'lastname':
                state.crews_memberOnCrew_Edited.crew.sort((a, b) => a.genLastname > b.genLastname ? 1 : -1);
                break;
            case 'department':
                state.crews_memberOnCrew_Edited.crew.sort((a, b) => a.genLastname > b.genLastname ? -1 : 1);
                state.crews_memberOnCrew_Edited.crew.sort((a, b) => a.sortingIndex > b.sortingIndex ? 1 : -1);
                break;
            default:
            //do nothing
        }

        state.crews_sortBy_MemberOfCrew = payload;

    }, // eo function mut_update_crews_SortBy_MemberOfCrew()


    /***************************************************************************
    * mut_sort_ResourcesOfDepartment()
    *
    * Desc: Sort Resources of Department
    * Note:
    *
    */
    mut_sort_ResourcesOfDepartment: (state) => {

        state.crews_resourcesOfDepartment_Filtered.sort((a, b) => a.genLastname > b.genLastname ? -1 : 1);
        state.crews_resourcesOfDepartment_Filtered.sort((a, b) => a.sortingIndex > b.sortingIndex ? 1 : -1);

    }, // eo function mut_sort_ResourcesOfDepartment()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Crews' - Load Crew(s) & More
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/crew/';
    *
    * Desc: Call: Get List of Crews.
    * Note:
    *
    */
    actn_call_getCrewsOnAirplane: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/crew/')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_CrewsOnAirplane', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCrewsOnAirplane()


    /***************************************************************************
    * Call::'humanresources/crew/' + idCrew;
    *
    * Desc: Call: Get Details of specific Crew.
    * Note:
    *
    */
    actn_call_getMemberOnCrew: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('/humanresources/crew/' + payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_MemberOnCrew', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getMemberOnCrew()


    /***************************************************************************
    * actn_set_getMemberOnCrew()
    *
    * Desc: Giving List of CrewCodes to buidl a Crew.
    * Note: Mimics Original (from 'People') Idea.
    *
    */
    actn_set_getMemberOnCrew: (context, payload) => {

        context.commit('find_crew_for_mut_set_MemberOnCrew', { response: payload.crewCodes, context: context });
        context.commit('set_crews_FlightData_FromCrewsToUpdate', payload.flightIds);

    }, // eo function actn_set_getMemberOnCrew()




    /***************************************************************************
    * Actions: 'Crews' - Update Crew
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/crew/';
    *
    * Desc: Call: Creates or Updates a Crew.
    * Note:
    *
    */
    actn_call_updateCreateCrew: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/crew';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();

        axios.put(url, payload.payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_updateCreateCrew', { response: response.data, editorMode: payload.editorMode, context: context });
                        eventBus.$emit('crewswasupdatedcreated'); // emit ..
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });
    }, // eo function actn_call_updateCreateCrew()




    /***************************************************************************
    * Actions: 'Crews' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/department/' + idDepartment;
    *
    * Desc: Call: Get List of ACTIVE Departments Ressources.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore this stupid Hack here.
    * Note: e.g.: payload => { department: '12', secondLoad: true }
    * Note: See: https://github.com/SundairIT/SunCrew-Crewplanning2/issues/17
    *
    */
    actn_call_crews_getResourcesOfDepartment: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        if (!payload.secondLoad) {
            Vue.prototype.$vp_m();
            context.commit('mut_reset_ResourcesOfDepartment'); // reset
        }


        axios.get('/humanresources/resource/department/' + payload.department) //  + '/active' => load inactive too
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_ResourcesOfDepartment', { response: response.data, secondLoad: payload.secondLoad, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesOfDepartment()


    /***************************************************************************
    * actn_reset_crews_MemberOnCrew
    *
    * Desc: Reset the memberOnCrew state.
    * Note:
    *
    */
    actn_reset_crews_MemberOnCrew: (context) => {

        context.commit('mut_reset_crews_MemberOnCrew');

    }, // eo funciton actn_reset_crews_MemberOnCrew


    /***************************************************************************
    * actn_reset_crews_ResourcesOfDepartment
    *
    * Desc: Reset the reourcesOfDepartment state.
    * Note:
    *
    */
    actn_reset_crews_ResourcesOfDepartment_Filtered: (context) => {

        context.commit('mut_reset_crews_ResourcesOfDepartment_Filtered', { context: context });

    }, // eo funciton actn_reset_crews_ResourcesOfDepartment


    /***************************************************************************
    * actn_update_crews_ResourcesOfDepartment
    *
    * Desc: Reset the memberOnCrew state.
    * Note:
    *
    */
    actn_update_crews_ResourcesOfDepartment: (context, payload) => {

        context.commit('mut_update_crews_ResourcesOfDepartment', payload);

    }, // eo funciton actn_update_crews_ResourcesOfDepartment


    /***************************************************************************
    * actn_update_crews_MemberOnCrew
    *
    * Desc: Update the memberOnCrew state.
    * Note:
    *
    */
    actn_update_crews_MemberOnCrew: (context, payload) => {

        context.commit('mut_update_crews_MemberOnCrew', payload);

    }, // eo funciton actn_update_crews_MemberOnCrew


    /***************************************************************************
    * actn_update_crews_FilterTerm_ResourcesOfDepartment
    *
    * Desc: Update the resources of department state.
    * Note:
    *
    */
    actn_update_crews_FilterTerm_ResourcesOfDepartment: (context, payload) => {

        context.commit('mut_update_crews_FilterTerm_ResourcesOfDepartment', { payload: payload, context: context });

    }, // eo funciton actn_update_crews_FilterTerm_ResourcesOfDepartment


    /***************************************************************************
    * actn_update_crews_SortBy_MemberOfCrew
    *
    * Desc: Update the sortby state.
    * Note:
    *
    */
    actn_update_crews_SortBy_MemberOfCrew: (context, payload) => {

        context.commit('mut_update_crews_SortBy_MemberOfCrew', payload)

    }, // eo funciton actn_update_crews_SortBy_MemberOfCrew()


    /***************************************************************************
    * actn_sort_ResourcesOfDepartment
    *
    * Desc: Sorts the resources of Department array.
    * Note:
    *
    */
    actn_sort_ResourcesOfDepartment: (context, payload) => {

        context.commit('mut_sort_ResourcesOfDepartment', payload)

    }, // eo funciton actn_sort_ResourcesOfDepartment()




    /***************************************************************************
    * Actions: 'Crews' - Small Buttons - Functions
    ***************************************************************************/
    /*************************************************************************** 'Roles'
    * Call::'/humanresources/resource/flight/roles2' (new)
    *
    * Desc:
    * Note:
    *
    */
    actn_call_crews_setFlightRoles: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/humanresources/resource/flight/roles2', payload.params)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createnewflightformember2', response.data); // Emit: create new Flight for Member (in 'Calendar')
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_crews_setFlightRoles()


    /*************************************************************************** 'DutyFlags'
    * Call::'/humanresources/resource/flight/dutyflags2' (new)
    *
    * Desc:
    * Note:
    *
    */
    actn_call_crews_setDutyFlags: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/humanresources/resource/flight/dutyflags2', payload)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createnewflightformember2', response.data); // Emit: create new Flight for Member (in 'Calendar')

                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_crews_setDutyFlags()




    /*************************************************************************** 'Commander Decsisions'
    * Call::'/humanresources/resource/flight/dutyextend' + idDepartment;
    *
    * Desc:
    * Note:
    *
    */
    actn_call_crews_setCommanderExtendedDecision: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/humanresources/resource/flight/dutyextend', payload)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // context.commit('mut_set_ResourcesOfDepartment', { response: response.data, secondLoad: payload.secondLoad, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_crews_setCommanderExtendedDecision()


    /*************************************************************************** 'CiCo Times'
    * Call::'/humanresources/resource/flight/dutytime'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_crews_setDutyTimes: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/humanresources/resource/flight/dutytime/multi', payload)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createnewflightformember2', response.data.extends4); // Emit: create new Flight/Ci/Co for Member (in 'Calendar')
                        context.commit('mut_call_getCrewDetailsHoursReport', { payload: response.data.reports, context: context, idFlight: null });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_crews_setDutyTimes()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};